import { render, staticRenderFns } from "./RegisterRoleForm.vue?vue&type=template&id=1d64b71c"
import script from "./RegisterRoleForm.vue?vue&type=script&lang=js"
export * from "./RegisterRoleForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports